import React, { useState, useEffect, useRef } from 'react';
import './ResetConfirmationSheet.css';

export function ResetTrafficConfirmationSheet({
                                           isVisible,
                                           onConfirm,
                                           onCancel,
                                           price,
                                           title = "Сброс трафика",
                                           warningText = "Трафик сбрасывается каждые 30 дней с момента активации подписки или по её истечению",
                                           nextResetInfo = null // Добавляем информацию о следующем сбросе
                                       }) {
    const [countdown, setCountdown] = useState(3);
    const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);
    const [startY, setStartY] = useState(null);
    const [currentY, setCurrentY] = useState(null);
    const sheetRef = useRef(null);
    const timerRef = useRef(null);

    // Блокируем прокрутку body при открытии шторки
    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = 'hidden';
            document.body.classList.add('sheet-open');
        } else {
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        }

        return () => {
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        };
    }, [isVisible]);

    useEffect(() => {
        if (isVisible) {
            setCountdown(3);
            setIsConfirmEnabled(false);

            timerRef.current = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        clearInterval(timerRef.current);
                        setIsConfirmEnabled(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, [isVisible]);

    const handleTouchStart = (e) => {
        setStartY(e.touches[0].clientY);
    };

    const handleTouchMove = (e) => {
        if (startY === null) return;

        const currentTouchY = e.touches[0].clientY;
        const diff = currentTouchY - startY;

        if (diff > 0) {
            e.preventDefault();
            setCurrentY(diff);

            if (sheetRef.current) {
                const maxTranslate = window.innerHeight * 0.5;
                const translateY = Math.min(diff, maxTranslate);
                sheetRef.current.style.transform = `translateY(${translateY}px)`;
            }
        }
    };

    const handleTouchEnd = (e) => {
        if (startY === null) return;

        const diff = currentY || 0;

        if (diff > 100) {
            handleCancel();
        }

        if (sheetRef.current) {
            sheetRef.current.style.transform = '';
        }

        setStartY(null);
        setCurrentY(null);
    };

    const handleMouseDown = (e) => {
        setStartY(e.clientY);

        const handleMouseMove = (e) => {
            if (startY === null) return;

            const diff = e.clientY - startY;

            if (diff > 0) {
                setCurrentY(diff);

                if (sheetRef.current) {
                    const maxTranslate = window.innerHeight * 0.5;
                    const translateY = Math.min(diff, maxTranslate);
                    sheetRef.current.style.transform = `translateY(${translateY}px)`;
                }
            }
        };

        const handleMouseUp = (e) => {
            const diff = currentY || 0;

            if (diff > 100) {
                handleCancel();
            }

            if (sheetRef.current) {
                sheetRef.current.style.transform = '';
            }

            setStartY(null);
            setCurrentY(null);

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleConfirm = () => {
        if (isConfirmEnabled) {
            onConfirm();
        }
    };

    const handleCancel = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }
        onCancel();
    };

    // Форматируем цену для отображения
    const getPriceText = () => {
        if (price === 0) {
            return "Бесплатно";
        }
        return `${price} ₽`;
    };

    // Определяем иконку в зависимости от типа операции
    const getIcon = () => {
        if (price === 0) {
            return "/images/refresh-circle.svg";
        }
        return "/images/warning-circle.svg";
    };

    return (
        <div className={`confirmation-sheet-wrapper ${isVisible ? 'visible' : ''}`}>
            <div
                className="sheet-overlay"
                onClick={handleCancel}
            />

            <div
                ref={sheetRef}
                className="confirmation-sheet reset-sheet res"
                style={{

                }}
            >
                <div className="sheet-content">
                    <div
                        className="sheet-drag-handle"
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        onMouseDown={handleMouseDown}
                    >
                        <div className="drag-indicator" />
                    </div>

                    <h3 className="sheet-title">
                        {title}
                    </h3>

                    {/*<p className="sheet-text">*/}
                    {/*    {price === 0 ? "Внимание! Это действие нельзя отменить" : "Внимание! Это действие платное"}*/}
                    {/*</p>*/}

                    <div className="custom-content-box">
                        <p className="custom-content-text1">
                            {warningText}
                        </p>

                        {/* Информация о следующем сбросе трафика */}
                        {nextResetInfo && (
                            <div className="reset-traffic-info-block">
                                {/*<div className="reset-info-divider"></div>*/}
                                <div className="reset-info-content">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" fill="#ff9800"/>
                                    </svg>
                                    <div className="reset-info-text">
                                        <span className="reset-info-label">Следующий плановый сброс через:</span>
                                        <span className="reset-info-value">{nextResetInfo}</span>
                                    </div>
                                </div>
                            </div>
                        )}

                        {price > 0 && (
                            <div style={{alignItems: 'center'}}>
                                <div className="reset-info-text1" style={{}}>
                                    <span className="custom-content-text1">{`Вы также можете платно сбросить \n\nтрафик в любой момент`}</span>

                                </div>
                            <div className="price-tag">
                                <span className="price-label-reset">Стоимость услуги:</span>
                                <span className="price-value1">
                                    {price} ₽
                                </span>
                            </div>
                            </div>
                        )}
                    </div>

                    {price === 0 && (
                        <p className="sheet-text">
                            Доступно раз в 3 часа
                        </p>
                    )}

                    <div className="sheet-buttons">
                        <button
                            className="sheet-button sheet-button-cancel"
                            onClick={handleCancel}
                        >
                            Отмена
                        </button>
                        <button
                            className={`sheet-button sheet-button-confirm ${!isConfirmEnabled ? 'disabled' : ''}`}
                            onClick={handleConfirm}
                            disabled={!isConfirmEnabled}
                        >
                            {isConfirmEnabled ? 'Подтвердить' : `Подождите ${countdown}с`}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}